export default "__VITE_ASSET__B44oTsW9__"